// extracted by mini-css-extract-plugin
export default {"header":"OrderCancellationOptions--header--f0373e","button":"OrderCancellationOptions--button--580ff2"};